import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IPostDepartmentsArgs,
  IPostDepartmentsResponseData,
} from "./postDepartments.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<IPostDepartmentsResponseData>;

export const postDepartments = (axios: IAxiosInstance) => {
  return async (params: IPostDepartmentsArgs) => {
    try {
      const response = await axios.noRetry.post<SuccessResponse>(
        `/api/departments`,
        params
      );
      return response?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
